/**
 * OfflineIndicator - Shows when user is offline and data is being served from cache
 */
import { useOffline } from '@/hooks/useOffline';
import { WifiOff, Cloud, CloudOff } from 'lucide-react';

export function OfflineIndicator({ className = "" }) {
  const { isOffline } = useOffline();

  // Only show when offline - simple approach
  if (!isOffline) {
    return null;
  }

  return (
    <div 
      className={`fixed bottom-4 left-4 z-50 flex items-center gap-2 px-4 py-2 rounded-lg shadow-lg bg-amber-500 text-white ${className}`}
      data-testid="offline-indicator"
    >
      <WifiOff className="w-4 h-4" />
      <span className="text-sm font-medium">You&apos;re offline</span>
      <span className="text-xs opacity-80">• Using cached data</span>
    </div>
  );
}

/**
 * OfflineBadge - Small badge to show offline status in headers/navbars
 */
export function OfflineBadge({ className = "" }) {
  const { isOffline } = useOffline();

  if (!isOffline) {
    return null;
  }

  return (
    <div 
      className={`flex items-center gap-1 px-2 py-1 bg-amber-100 text-amber-700 rounded-full text-xs font-medium ${className}`}
      title="You&apos;re offline - using cached data"
    >
      <CloudOff className="w-3 h-3" />
      <span>Offline</span>
    </div>
  );
}

export default OfflineIndicator;
